import * as React from 'react';
import { connect } from 'react-redux';

import { FromToControl } from '../../../../common/components/from_to_control';
import { IAppState, Dispatch } from '../../../../common/state';
import { IJsonQueryRangeValue } from '../../../../json_query';
import { FOfferType, isSuburban } from '../../../../utils/category';
import { changeMaxHouseYear, changeMinHouseYear } from '../../../state/advanced/house_year';
import { InlineParam, Row } from '../markup';

const MAX_YEAR_LENGTH = 4;
interface IHouseYearProps {
  houseYear: { gte?: number; lte?: number };
  onMinYearChanged(value: number | undefined): void;
  onMaxYearChanged(value: number | undefined): void;

  offerType: FOfferType;
}

interface IHouseYearState {
  minYear: number | undefined;
  maxYear: number | undefined;
}

const YEAR_MIN_VALUE = 1900;

class HouseYear extends React.Component<IHouseYearProps, IHouseYearState> {
  public constructor(props: IHouseYearProps) {
    super(props);

    this.state = {
      minYear: props.houseYear.gte,
      maxYear: props.houseYear.lte,
    };
  }

  public componentWillReceiveProps(props: IHouseYearProps) {
    this.state = {
      minYear: props.houseYear.gte,
      maxYear: props.houseYear.lte,
    };
  }

  public render() {
    const title = `Год постройки${isSuburban(this.props.offerType) ? ' дома' : ''}`;

    return (
      <Row title={title}>
        <InlineParam>
          <FromToControl
            rangeGroupStyle={{ width: 120 }}
            from={{
              onValueChange: (value: number) => {
                this.setState({
                  minYear: value,
                });
              },
              onBlur: this.onMinYearBlurred,
              value: this.state.minYear,
              disablePrettyFormating: true,
              maxLength: MAX_YEAR_LENGTH,
            }}
            to={{
              onValueChange: (value: number) => {
                this.setState({
                  maxYear: value,
                });
              },
              onBlur: this.onMaxYearBlurred,
              value: this.state.maxYear,
              disablePrettyFormating: true,
              maxLength: MAX_YEAR_LENGTH,
            }}
          />
        </InlineParam>
      </Row>
    );
  }

  private onMinYearBlurred = (event: React.FocusEvent<EventTarget>): void => {
    this.props.onMinYearChanged(
      this.state.minYear === undefined
        ? undefined
        : this.state.minYear >= YEAR_MIN_VALUE
        ? this.state.minYear
        : YEAR_MIN_VALUE,
    );
  };

  private onMaxYearBlurred = (event: React.FocusEvent<EventTarget>): void => {
    this.props.onMaxYearChanged(
      this.state.maxYear === undefined
        ? undefined
        : this.state.maxYear >= YEAR_MIN_VALUE
        ? this.state.maxYear
        : YEAR_MIN_VALUE,
    );
  };
}

// tslint:disable-next-line:no-default-export
export default connect<
  {
    houseYear: IJsonQueryRangeValue | undefined;
  },
  {
    onMinYearChanged(value: number | undefined): void;
    onMaxYearChanged(value: number | undefined): void;
  },
  {
    offerType: FOfferType;
  }
>(
  (state: IAppState) => ({
    houseYear: (state.filters.jsonQuery.house_year && state.filters.jsonQuery.house_year.value) || {},
  }),
  (dispatch: Dispatch) => ({
    onMinYearChanged: (value: number | undefined) => {
      dispatch(changeMinHouseYear(value));
    },
    onMaxYearChanged: (value: number | undefined) => {
      dispatch(changeMaxHouseYear(value));
    },
  }),
)(HouseYear);
